import { createAction } from 'redux-act'

import { ListingSectionObject } from '../../transports/common/listing-section-transport'
import { SELECT_LISTING, DESELECT_LISTING, CLEAR_SELECTION, SET_SELECT_MODE, SET_FILTER_CONTEXT } from './action-types'

export const selectListing = createAction<ListingSectionObject>(SELECT_LISTING)
export const deselectListing = createAction<string>(DESELECT_LISTING)
export const clearSelection = createAction(CLEAR_SELECTION)
export const setSelectMode = createAction<boolean>(SET_SELECT_MODE)
export const setFilterContext = createAction<string>(SET_FILTER_CONTEXT)
